<template>
    <div class="container">
        <b-modal 
            :model-value="modModElimAct" 
            @update:model-value="updateModalValue"
            :no-close-on-backdrop="true" 
            hide-header 
            hide-footer 
            centered
            size="md"
        >
            <div class="text-center mb-3">
                <h5>{{ labels.title }}</h5> 
            </div>
            
            <div>
                <b-row class="mt-3 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="font-weight-bold">{{ labels.valorAdicion }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input 
                            type="number" 
                            v-model.number="valAdicion"
                            class="form-control"
                            min="0"
                            step="0.01"
                            placeholder="0.00"
                        >
                    </b-col>
                </b-row>
                
                <b-row class="mt-3 align-items-center">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <label class="font-weight-bold">{{ labels.valorRetiro }}</label> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input 
                            type="number" 
                            v-model.number="valRetiro"
                            class="form-control"
                            min="0"
                            step="0.01"
                            placeholder="0.00"
                        >
                    </b-col>
                </b-row>
                
                <b-row class="mt-4 d-flex justify-content-end gap-2">
                    <b-col cols="3">
                        <b-button 
                            variant="primary" 
                            @click="guardarAddRet()"
                            block
                            :disabled="valAdicion === 0 && valRetiro === 0"
                        >
                            {{ labels.save }}
                        </b-button>
                    </b-col>
                    <b-col cols="3">
                        <b-button 
                            variant="danger" 
                            @click="quitaActivo()"
                            block
                        >
                            {{ labels.quitar }}
                        </b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button 
                            variant="secondary" 
                            @click="cierraModal"
                            block
                        >
                            {{ labels.close }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        
        <InacticaItem 
            :InactivaItem="showAdvQuitAct" 
            @confirmDelete="confirmInactivate" 
            @cierraModal="cierraModalAdv"
        />
    </div>
</template>

<script>
import InacticaItem from '../utils/InacticaItem.vue' 
import Activos from '../../services/Activos' 

export default {
    name: 'ModModifiElimAct',
    props: {
        modModElimAct: {
            type: Boolean,
            required: true,
            default: false
        },
        numActivo: {
            type: [String, Number],
            required: true
        },
        nroContrato: {
            type: [String, Number],
            required: true
        }
    },
    components: {
        InacticaItem
    },
    data() {
        return {
            valAdicion: 0,
            valRetiro: 0,
            showAdvQuitAct: false,
            isLoading: false
        }
    },
    computed: {
        labels() {
            const isSpanish = this.$store.state._language === "es-ES"
            return {
                title: isSpanish ? 'Adición o retiro' : 'Addition or withdrawal',
                valorAdicion: isSpanish ? 'Valor adición:' : 'Added value:',
                valorRetiro: isSpanish ? 'Valor retiro:' : 'Withdrawal value:',
                quitar: isSpanish ? 'Quitar' : 'Remove',
                save: isSpanish ? 'Guardar' : 'Save',
                close: isSpanish ? 'Cerrar' : 'Close'
            }
        }
    },
    methods: {
        updateModalValue(value) {
            this.$emit('update:modModElimAct', value)
            if (!value) {
                this.limpiaInp()
            }
        },
        
        cierraModal() {
            this.$emit('update:modModElimAct', false)
            this.$emit('cierraModal', false)
            this.limpiaInp()
        },
        
        cierraModalAdv() {
            this.showAdvQuitAct = false 
        },
        
        quitaActivo() {
            this.showAdvQuitAct = true 
        },
        
        async confirmInactivate() {
            if (this.isLoading) return
            
            this.isLoading = true
            
            try {
                const info = {
                    'activo': this.numActivo,
                    'numContrato': this.nroContrato,
                    'idUser': this.$store.state.userId
                }

                const res = await Activos.quitarActivoAlContrato(info)
                
                if (res.status === 200) {
                    this.$toast.success(res.data.message)
                    this.showAdvQuitAct = false
                    this.cierraModal()
                    
                    // Emitir evento para actualizar la tabla
                    this.$emit('refreshTblModAct')
                    this.$emit('activoEliminado')
                    
                    // Navegar sin recargar bruscamente
                    setTimeout(() => {
                        this.$router.push('modificarcontrato')
                    }, 500)
                }
            } catch (error) {
                console.error('Error al quitar activo:', error)
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message)
                } else {
                    this.$toast.error(this.$store.state._language === "es-ES" 
                        ? 'Error al quitar el activo' 
                        : 'Error removing asset'
                    )
                }
            } finally {
                this.isLoading = false
            }
        },
        
        async guardarAddRet() {
            // Validar que al menos un valor sea mayor a 0
            if (this.valAdicion === 0 && this.valRetiro === 0) {
                this.$toast.warning(this.$store.state._language === "es-ES" 
                    ? 'Debe ingresar al menos un valor' 
                    : 'You must enter at least one value'
                )
                return
            }
            
            if (this.isLoading) return
            
            this.isLoading = true
            
            try {
                const info = {
                    activo: this.numActivo,
                    valor_adicion: this.valAdicion || 0,
                    valor_retiro: this.valRetiro || 0,
                    idUser: this.$store.state.userId
                }

                const res = await Activos.mejoraRetiro(info)
                
                if (res.status === 200) {
                    this.$emit('refreshTblModAct')
                    this.cierraModal()
                    this.$toast.success(res.data.message)
                    this.limpiaInp()
                }
            } catch (error) {
                console.error('Error al guardar:', error)
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message)
                } else if (error.response && error.response.status === 500) {
                    this.$toast.error(this.$store.state._language === "es-ES" 
                        ? 'Error interno del servidor' 
                        : 'Internal server error'
                    )
                } else {
                    this.$toast.error(this.$store.state._language === "es-ES" 
                        ? 'Error al guardar los cambios' 
                        : 'Error saving changes'
                    )
                }
            } finally {
                this.isLoading = false
            }
        },
        
        limpiaInp() {
            this.valAdicion = 0
            this.valRetiro = 0
        }
    },
    watch: {
        modModElimAct(newValue) {
            if (newValue) {
                // Resetear valores al abrir la modal
                this.limpiaInp()
            }
        }
    }
}
</script>

<style scoped>
.gap-2 {
    gap: 0.5rem;
}

/* Mejorar estilo de los inputs */
input[type="number"].form-control {
    font-size: 1rem;
    padding: 0.375rem 0.75rem;
}

input[type="number"].form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Eliminar spinners en inputs number */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>
